<template>
  <div class="user_wrap">
    <div class="top_header">
      <div class="user_detail">
        <span class="user_header">
                 <img src="../images/user/12.png" alt="" width="35px" />
        </span>
        <span class="user_name">
          <div class="user_all">
            <p class="user_nickname">
              {{ data.name ? data.name : data.mobile }}
              <!-- <img src="../images/user/vip.png" alt="" width="35px" /> -->
            </p>
            <p class="user_type">普遍用户</p>
          </div>
        </span>
        <!-- 邀请码移到右侧 -->
    <!--    <div class="invite_code_right" @click="copyInviteCode" :class="{copy_success: isCopied}">
          <div class="invite_code_content">
            <span class="invite_label">我的邀请码</span>
            <span class="invite_code">{{ data.uid }}</span>
            <span class="copy_btn">复制</span>
          </div>
        </div> -->
      </div>
      <div class="money-box">
        <div class="money-item">
          <div class="currency-display">
            <span class="rmb">￥{{ data.money }}</span>
            <span class="usd">${{ (data.money / 7.2).toFixed(2) }}</span>
          </div>
          <p class="money-title">账户余额</p>
        </div>
        <div class="money-item">
          <p class="money-num">
            ￥{{ data.wait_lixi }}
          </p>
          <p class="money-title">待收利息</p>
        </div>
        <div class="money-item money-item-bg">
          <p class="money-num">
            ￥{{ data.wait_money }}
          </p>
          <p class="money-title">待收本金</p>
        </div>
      </div>
    </div>

    <div class="body-content">
      <div class="money">
        <div class="money-bd">
          <span @click="$router.push('/kefu')">
            <div style="display: inline-block; float: left">
              <h3>充值</h3>
              <p>充值服务</p>
            </div>
            <div style="display: inline-block; float: right">
              <img src="../images/user/wallet.png" alt="" />
            </div>
          </span>
          <span @click="$router.push('/cash')">
            <div style="display: inline-block; float: left">
              <h3>提现</h3>
              <p>提现服务</p>
            </div>
            <div style="display: inline-block; float: right">
              <img src="../images/user/tx_service.png" alt="" />
            </div>
          </span>
        </div>
      </div>
      <div class="clear" />
      <div class="work_box">
        <div class="title">全部服务</div>
        <div class="content">
          <ul>
            <li>
              <img
                src="../images/user/s1.png"
                @click="$router.push('/moneybag')"
              />
              <p>资金明细</p>
            </li>
            <li>
              <img
                src="../images/user/s2.png"
                @click="$router.push('/order')"
              />
              <p>认购记录</p>
            </li>
            <li>
              <img
                src="../images/user/s3.png"
                @click="$router.push('/rechargeRecord')"
              />
              <p>充值记录</p>
            </li>
            <li>
              <img
                src="../images/user/s4.png"
                @click="$router.push('/earnings')"
              />
              <p>收益记录</p>
            </li>
            <li>
              <img
                src="../images/user/s5.png"
                @click="$router.push('/withdrawRecord')"
              />
              <p>提现记录</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="work_box">
        <div class="title">基础服务</div>
        <div class="content">
          <ul class="basic_service">
            <li>
              <img
                src="../images/user/bs1.png"
                @click="jump('https://www.okx.com/zh-hans/download')"
              />
              <p>欧易安卓下载</p>
            </li>
            <li>
              <img
                src="../images/user/bs2.png"
                @click="jump('https://www.binance.com/zh-CN')"
              />
              <p>币安安卓下载</p>
            </li>
            <li>
              <img
                src="../images/user/bs3.png"
                @click="jump('https://www.htx.com/zh-cn')"
              />
              <p>火币安卓下载</p>
            </li>
            <li>
              <img
                src="../images/user/bs4.png"
                @click="$router.push('/safety')"
              />
              <p>账户安全</p>
            </li>
           <!-- <li>
              <img
                src="../images/user/bs5.png"
                @click="$router.push('/sign')"
              />
              <p>每日签到</p>
            </li> -->
            <li>
              <img
                src="../images/user/bs6.png"
                @click="$router.push('/bank')"
              />
              <p>银行卡绑定</p>
            </li>
            <li>
              <img
                src="../images/user/bs7.png"
                @click="$router.push('/setrealinfo')"
              />
              <p>实名认证</p>
            </li>
            <li>
              <img
                src="../images/user/bs8.png"
                @click="$router.push('/account')"
              />
              <p>USDT绑定地址</p>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="history_coupon basic_btn flex_center logout_btn"
        @click="logout"
      >
        <span>退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import qs from 'qs'
  import Fetch from '../../utils/fetch'
  import Api from '../../interface/index'
  import { Icon, Cell, CellGroup } from 'vant'

  Vue.use(Cell).use(CellGroup).use(Icon)

  export default {
    name: 'User',
    components: {},
    data() {
      return {
        data: {},
        eye: 1,
        checked: true,
        isCopied: false, // 新增复制状态
      }
    },
    created() {
      this.$parent.footer('user')
    },
    mounted() {
      document.body.style.backgroundColor = '#f5f5f7'
      this.start()
    },
    methods: {
      jump(url) {
        window.open(url)
      },
      start() {
        Fetch('/user/info').then((r) => {
          this.data = r.data
        })
      },
      logout() {
        localStorage.removeItem('token')
        this.$router.replace('/')
      },
      // 新增复制邀请码功能
      async copyInviteCode() {
        if (!this.data.uid) {
          this.$toast('邀请码不存在')
          return
        }
        
        try {
          // 使用Clipboard API
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.data.uid)
            this.showCopySuccess()
          } else {
            // 降级方案
            const input = document.createElement('input')
            input.value = this.data.uid
            document.body.appendChild(input)
            input.select()
            const successful = document.execCommand('copy')
            document.body.removeChild(input)
            
            if (successful) {
              this.showCopySuccess()
            } else {
              this.$toast('复制失败，请手动复制')
            }
          }
        } catch (err) {
          console.error('复制失败:', err)
          this.$toast('复制失败，请手动复制')
        }
      },
      // 显示复制成功效果
      showCopySuccess() {
        this.$toast('邀请码复制成功')
        this.isCopied = true
        setTimeout(() => {
          this.isCopied = false
        }, 500)
      }
    },
  }
</script>

<style lang="less" scoped>
	.currency-display {
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	}
	
	.currency-display .rmb {
	  font-size: 20px;
	  color: #fff;
	  margin-bottom: 5px;
	}
	
	.currency-display .usd {
	  font-size: 16px;
	
	}
  .red_top_bg {
    position: relative;
    background: unset;

    .sign {
      position: absolute;
      top: 15px;
      right: 15px;
      height: 20px;

      img {
        height: 100%;
      }
    }
  }

  .user_block {
    padding: 10px 15px;

    .user_kf {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      background-image: linear-gradient(to right, #ff5252, #ff8244);
      box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
      color: #fff;
      font-size: 12px;
      padding: 10px;

      img {
        width: 27px;
        height: 27px;
        margin-right: 8px;
      }
    }

    .user_grid {
      margin: 0 -7.5px;

      .user_grid__item {
        float: left;
        width: 50%;
        padding: 0 7.5px;
        box-sizing: border-box;

        .user_grid__card {
          border: 1px solid #eeeeee;
          background-color: #fff;
          border-radius: 5px;
          box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
          margin-bottom: 10px;
          text-align: center;
          padding: 12px;
        }

        .user_money {
          p:nth-child(1) {
            font-size: 12px;
            color: #999992;
          }

          p:nth-child(2) {
            font-size: 12px;
            color: #ef5040;
            margin-top: 8px;
          }
        }

        .user_balance {
          div:nth-child(1) {
            font-size: 12px;
            color: #999992;
          }

          div:nth-child(2) {
            font-size: 12px;
            color: #ef5040;
            margin-top: 8px;
          }
        }
      }
    }
  }

  .user_wrap {
    max-width: 100%;
    overflow: hidden;
    padding-bottom: 20px;
  }

  .top_header {
    position: relative;
    width: 100%;
    height: 200px;
    background: linear-gradient(to bottom, #5674d3, #a8b6e5);
    .user_detail {
      width: 100%;
      padding: 40px 15px 0;
      background: url('../images/user/head_bg.png') no-repeat;
      background-position: 20px center;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      
      .user_header {
        width: 48px;
        height: 48px;
        overflow: hidden;
        border-radius: 50%;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          border: 2px solid #ffffff;
          border-radius: 30px;
        }
      }

      .user_name {
        flex: 1;
        margin-left: 10px;
        color: #ffffff;
        text-align: left;

        .user_all {
          .user_nickname {
            line-height: 22px;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
          }
          .user_type {
            background-color: #fff;
            color: #000;
            padding: 4px 8px;
            border-radius: 20px;
            display: inline-block;
            font-size: 12px;
          }
        }
      }

      /* 右侧邀请码样式 */
      .invite_code_right {
        flex-shrink: 0;
        margin-left: 15px;
        cursor: pointer;
        transition: all 0.3s;

        .invite_code_content {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          padding: 8px 12px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          display: flex;
          flex-direction: column;
          align-items: center;
          min-width: 80px;
          transition: background 0.3s;
        }

        .invite_label {
          font-size: 12px;
          color: #fff;
          opacity: 0.9;
          margin-bottom: 4px;
        }

        .invite_code {
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          letter-spacing: 1px;
          margin-bottom: 4px;
        }

        .copy_btn {
          background: rgba(255, 255, 255, 0.3);
          padding: 2px 8px;
          border-radius: 8px;
          font-size: 10px;
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.5);
        }

        &:hover {
          transform: scale(1.05);
          .invite_code_content {
            background: rgba(255, 255, 255, 0.25);
          }
        }

        /* 复制成功动画 */
        &.copy_success {
          .invite_code_content {
            animation: copyFlash 0.5s ease-in-out;
          }
        }
      }
    }

    .user_vip {
      color: #ffffff;
      text-align: center;
      padding: 8px 15px;

      .vip-box {
        position: relative;
        text-align: center;
        font-size: 12px;
        min-width: 45px;
        padding: 0 14px;
        line-height: 15px;
        border-radius: 8px;
        display: inline-block;
        background-image: linear-gradient(to right, #ffa51e, #ffe462);

        .vip-badge {
          position: absolute;
          left: -8px;
          top: -2.5px;
          width: 20px;
          height: 20px;
          background-image: url(../images/user/badge.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .user_balance {
      text-align: center;

      div {
        margin: 10px 0;
      }

      div:nth-child(1) {
        font-size: 14px;
        color: #d3d5d6;
      }

      div:nth-child(2) {
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
      }
    }

    .user_money {
      display: flex;
      justify-content: space-between;
      text-align: center;

      p {
        margin: 10px 0;
      }

      div {
        width: 33.33%;
      }

      p:nth-child(1) {
        font-size: 14px;
        color: #d3d5d6;
      }

      p:nth-child(2) {
        font-size: 14px;
        color: #ffffff;
      }
    }
  }

  /* 复制成功动画 */
  @keyframes copyFlash {
    0% { 
      background: rgba(76, 175, 80, 0.3);
      box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
    }
    50% { 
      background: rgba(76, 175, 80, 0.6);
      box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.3);
    }
    100% { 
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
    }
  }

  .kong {
    width: 100%;
    height: 35px;
    background: #ffffff;
  }

  .user_yw {
    display: flex;
    justify-content: space-between;
    text-align: center;
    width: 96%;
    position: relative;
    background: #ffffff;
    left: 2%;
    border-radius: 5px 5px 0 0;
    padding: 15px 0;

    div {
      width: 33.33%;
    }

    p {
      margin-top: 8px;
    }

    img {
      width: 30px;
      height: 30px;
    }
  }

  .money {
    .money-hd {
      text-align: center;

      p:nth-child(1) {
        color: #999;
        margin-bottom: 10px;
      }

      p:nth-child(2) {
        font-size: 14px;
        color: #ff5252;
        font-weight: bold;
      }
    }

    .money-bd {
      text-align: center;
      margin-top: 13px;

      span {
        padding: 0.3rem;
        border-radius: 5px;
        width: 48%;
        font-size: 14px;
        display: inline-block;
        color: #ffffff;
        float: left;
        height: 1.8rem;
        h3 {
          text-align: left;
          color: #0e0546;
          font-size: 16px;
          line-height: 30px;
        }
        p {
          color: #0e0546;
          font-size: 16px;
        }
      }

      span:nth-child(1) {
        background: linear-gradient(to right, #dce4f8, #eef1fd);
        float: left;
      }

      span:nth-child(2) {
        background: linear-gradient(to right, #fffaea, #fff2bf);
        float: right;
      }
    }
  }

  .list {
    margin-top: 10px;

    .van-cell {
      padding: 8px 15px;
      .van-cell__title {
        display: flex;
        align-items: center;
        color: #333333;
        font-size: 12px;

        img {
          height: 17px;
          width: 17px;
          margin-right: 6px;
          vertical-align: middle;
        }
      }
    }

    .van-cell::after {
      left: 0;
      right: 0;
      border-bottom: 1px solid #ebe9e9;
    }
  }
  .money-box {
    padding: 15px;
    margin-top: 10px;
  }
  .money-box .money-item {
    width: 33.33%;
    float: left;
    text-align: center;
    color: #fff;
  }
  .money-box .money-item .money-title {
    font-size: 14px;
    margin-top: 10px;
  }
  .money-box .money-item .money-num {
    font-size: 20px;
  }
  .money-item-bg {
    background: url('../images/user/head_bg.png') top right no-repeat;
  }
  .body-content {
    margin-top: -10px;
    position: relative;
    border-radius: 10px;
    border: 1px solid #f5f5f7;
    padding: 0px 15px 15px 15px;
    background-color: #f5f5f7;
  }
  .clear {
    float: none;
    clear: both;
  }
  .work_box {
    background: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-radius: 10px;
    margin-top: 15px;
    .title {
      border-bottom: 1px solid #eee;
      display: block;
      width: 100%;
      line-height: 40px;
      height: 40px;
      padding: 0px 10px;
      font-size: 16px;
    }
    .content {
      padding: 10px;
      width: 100%;
      ul li {
        width: 20%;
        float: left;
        text-align: center;
        margin-bottom: 10px;
        img {
          height: 32px;
        }
        p {
          line-height: 30px;
        }
      }
      ul.basic_service li {
        width: 25%;
      }
    }
  }
  .logout_btn {
    background: #e15241;
    width: 100%;
    margin-top: 15px;
  }
</style>